/* eslint-disable */
import React, { useState, useMemo } from 'react';
import {
    MaterialReactTable,
} from 'material-react-table';
import {
    Box, IconButton, Button, Chip, Tooltip, Stack
} from '@material-ui/core';
import _ from 'lodash';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';

export function CustomTable({ tableData, factoryType, setEditFarmer, setApproveFarmer, setApproveStatus, setRejectFarmer, setRejectStatus, setApproveFarmerCode, setApproveGivenName, setApprovecollectionCenterID, setApproveNavisionNumber, setEditFarmerCollectionCenterID }) {

    const preparedData = useMemo(() => tableData.map(row => ({
        ...row,
        displayName: row.modeOfOperation === 1
            ? (row.givenName != null ?
                row.givenName : row.businessName)
            : (row.modeOfOperation === 2
                ? row.givenName
                : ""),
    })), [tableData]);

    const highlightText = (text, searchTerm) => {
        if (!searchTerm) return text;
        const parts = text.split(new RegExp(`(${searchTerm})`, 'gi'));
        return parts.map((part, index) =>
            part.toLowerCase() === searchTerm.toLowerCase() ? (
                <span key={index} style={{ backgroundColor: 'yellow', fontWeight: 'bold' }}>
                    {part}
                </span>
            ) : (
                part
            )
        );
    };

    const columns = useMemo(
        () => [
            {
                accessorKey: 'registrationNumber',
                header: 'Supplier Code',
                size: 150
            },
            {
                accessorKey: 'displayName',
                header: 'Business / Supplier Name',
                size: 290,
                filterFn: (rows, id, filterValue) => {
                    return rows.filter(row => {
                        const modeOfOperation = row.original.modeOfOperation;
                        const nameToFilter = modeOfOperation === 1 ? row.original.businessName : (modeOfOperation === 2 ? row.original.givenName : " - ");
                        return nameToFilter.toLowerCase() === filterValue.toLowerCase();
                    });
                },
                Cell: ({ row, table }) => {
                    const searchValue = table.getState().globalFilter || '';
                    const displayName = row.original.displayName || ' - ';
                    return highlightText(displayName, searchValue);
                },
            },
            {
                accessorKey: 'farmerTypeID',
                header: 'Supplier Type',
                size: 180,
                Cell: ({ row }) => {
                    return row.original.farmerTypeID === 1 ? "Farmer" : row.original.farmerTypeID === 2 ? "Collector" : row.original.farmerTypeID === 3 ? "Farmer & Collector" : " - ";
                }
            },
            {
                accessorKey: 'mobileNumber',
                header: 'Phone Number',
                size: 180
            },
            {
                accessorKey: 'nic',
                header: 'NIC / BRN',
                size: 180
            },
            {
                accessorKey: 'activeStatus',
                header: 'State',
                size: 150,
                Cell: ({ row }) => {
                    if (row.original.activeStatus === true) {
                        return <Chip size="small" label="Active" style={{ color: 'green' }} />
                    }
                    if (row.original.activeStatus === false) {
                        return <Chip size="small" label="Inactive" style={{ color: 'red' }} />
                    }
                },
                enableColumnActions: false
            },
            {
                accessorKey: 'farmerStatus',
                header: 'Status',
                size: 150,
                Cell: ({ row }) => {
                    const status = row.original.farmerStatus;
                    
                    if (status === 1) {
                        return <Chip size="small" label="New" style={{ color: 'green' }} />
                    }
                    if (status === 2) {
                        return <Chip size="small" label="FCC Approved" style={{ color: 'orange' }} />
                    }
                    if (status === 3) {
                        return <Chip size="small" label="FDC First Approved" style={{ color: '#B414F9' }} />
                    }
                    if (status === 4) {
                        return <Chip size="small" label="FDC Second Approved" style={{ color: 'blue' }} />
                    }
                    if (status === 5) {
                        return <Chip size="small" label="FCC Rejected" style={{ color: 'red' }} />
                    }
                    if (status === 6) {
                        return <Chip size="small" label="FDC First Rejected" style={{ color: 'red' }} />
                    }
                    if (status === 7) {
                        return <Chip size="small" label="FDC Second Rejected" style={{ color: 'red' }} />
                    }
                    return <Chip size="small" label="Active" style={{ color: 'green' }} />
                },
                enableColumnActions: false
            }
        ],
        [],
    );

    function EditFarmer(farmerID, collectionCenterID) {
        setEditFarmer(farmerID)
        setEditFarmerCollectionCenterID(collectionCenterID)
    }

    function handleConfirm(farmerID, status, farmerCode, givenName, collectionCenterID, navisionNumber) {
        setApproveFarmer(farmerID)
        setApproveStatus(status)
        setApproveFarmerCode(farmerCode)
        setApproveGivenName(givenName)
        setApprovecollectionCenterID(collectionCenterID)
        setApproveNavisionNumber(navisionNumber)
    }

    function handleReject(farmerID, status, farmerCode, givenName, collectionCenterID, navisionNumber) {
        setRejectFarmer(farmerID)
        setRejectStatus(status)
        setApproveFarmerCode(farmerCode)
        setApproveGivenName(givenName)
        setApprovecollectionCenterID(collectionCenterID)
        setApproveNavisionNumber(navisionNumber)
    }


    return (
        <div>
            <MaterialReactTable
                columns={columns}
                data={preparedData}
                enableFullScreenToggle={false}
                enableHiding={false}
                enableRowActions
                enableColumnActions={false}
                muiSearchTextFieldProps={{
                    placeholder: `Search`,
                    sx: { minWidth: '300px' },
                    variant: 'outlined'
                }}
                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        grow: false,
                        Header: () => (
                            <Box sx={{ display: 'flex', flexWrap: 'nowrap', justifyContent: 'center' }}>
                                <Box style={{ marginLeft: '36px' }}>Actions</Box>
                            </Box>
                        ),
                    }
                }}
                positionActionsColumn='last'
                renderRowActions={({ row, table }) => (
                    <Box sx={{ display: 'flex', flexWrap: 'nowrap', justifyContent: 'center' }}>
                        {(factoryType === 1 || factoryType === 3) ?
                            <Tooltip title="View Farmer">
                                <IconButton
                                    aria-label="delete"
                                    onClick={(e) => EditFarmer(row.original.farmerID, row.original.collectionCenterID)}
                                >
                                    <VisibilityIcon />
                                </IconButton>
                            </Tooltip>
                            :
                            <Tooltip title="Edit Farmer">
                                <IconButton
                                    aria-label="delete"
                                    onClick={(e) => EditFarmer(row.original.farmerID, row.original.collectionCenterID)}
                                >
                                    <EditIcon />
                                </IconButton>
                            </Tooltip>
                        }
                        {(factoryType === 2) && (row.original.farmerStatus === 1) ?
                            <>
                                <Tooltip title="FCC Approve">
                                    <IconButton
                                        aria-label="delete"
                                        onClick={(e) => handleConfirm(row.original.farmerID, 2, row.original.farmerCode, row.original.givenName, row.original.collectionCenterID, row.original.navisionNumber)}
                                    >
                                        <CheckIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="FCC Reject">
                                    <IconButton
                                        aria-label="delete"
                                        onClick={(e) => handleReject(row.original.farmerID, 5, row.original.farmerCode, row.original.givenName, row.original.collectionCenterID, row.original.navisionNumber)}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                </Tooltip>
                            </>
                            : null}
                        {(factoryType === 1 || factoryType === 3) && (row.original.farmerStatus === 2) ?
                            <>
                                <Tooltip title="FDC First Approve">
                                    <IconButton
                                        aria-label="delete"
                                        onClick={(e) => handleConfirm(row.original.farmerID, 3, row.original.farmerCode, row.original.givenName, row.original.collectionCenterID, row.original.navisionNumber)}
                                    >
                                        <CheckIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="FDC First Reject">
                                    <IconButton
                                        aria-label="delete"
                                        onClick={(e) => handleReject(row.original.farmerID, 6, row.original.farmerCode, row.original.givenName, row.original.collectionCenterID, row.original.navisionNumber)}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                </Tooltip>
                            </>
                            : null}
                        {(factoryType === 1 || factoryType === 3) && (row.original.farmerStatus === 3) ?
                            <>
                                <Tooltip title="FDC Second Approve">
                                    <IconButton
                                        aria-label="delete"
                                        onClick={(e) => handleConfirm(row.original.farmerID, 4, row.original.farmerCode, row.original.givenName, row.original.collectionCenterID, row.original.navisionNumber)}
                                    >
                                        <CheckIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="FDC Second Reject">
                                    <IconButton
                                        aria-label="delete"
                                        onClick={(e) => handleReject(row.original.farmerID, 7, row.original.farmerCode, row.original.givenName, row.original.collectionCenterID, row.original.navisionNumber)}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                </Tooltip>
                            </>
                            : null}
                    </Box>
                )}
                initialState={{ density: 'compact', showGlobalFilter: true }}
            />
        </div>
    );
};
